import '../stylesheets/styles.scss';

import 'core-js';

import 'bootstrap-italia';
// import 'select2';

import './utils/imagesConfig';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/respimg/ls.respimg';

import { PageData, Cookies, Keyboard, Logger, Responsive, Translations } from './utils'; // eslint-disable-line object-curly-newline
import { asyncSVG } from './libs/asyncSVG';
import { Header } from './components/header';
import { Footer } from './components/footer';
import { Page } from './components/page';
import { Pagination } from './components/pagination';
import { Breadcrumbs } from './components/breadcrumbs';
import { Hero } from './components/hero';
import { HeroCards } from './components/hero-cards';
import { MediaWrapper } from './components/media-wrapper';
import { Numbers } from './components/numbers';
import { ContentWrapper } from './components/content-wrapper';
import { TwoColumns } from './components/two-columns';
import { Banner } from './components/banner';
import { Faq } from './components/faq';
import { ImmobiliSlider } from './components/immobili-slider';
import { Card } from './components/card';
import { ContactModal } from './components/contact-modal';
import { Intestazione } from './components/intestazione';
import { PortfolioImmobiliareFilterButtons } from './components/portfolio-immobiliare-filter-buttons';
import { PortfolioImmobiliareFilters } from './components/portfolio-immobiliare-filters';
import { PortfolioImmobiliareSorter } from './components/portfolio-immobiliare-sorter';
import { PortfolioImmobiliareListing } from './components/portfolio-immobiliare-listing';
import { ShareOn } from './components/share-on';
import { AvvisiGara } from './components/avvisi-gara';
import { DualColumnInfo } from './components/dual-column-info';
import { DocumentiCorrelati } from './components/documenti-correlati';
import { GalleryImmobile } from './components/gallery-immobile';
import { ImmobileTitle } from './components/immobile-title';
import { ImmobileContent } from './components/immobile-content';
import { ImmobileImageComparison } from './components/immobile-image-comparison';
import { ImmobileGalleryMosaic } from './components/gallery-mosaic';
import { ContenutoAccordion } from './components/contenuto-accordion';
import { PrivacyPolicyTable } from './components/privacy-policy-table';

if (!('object-fit' in document.createElement('a').style)) {
  require('lazysizes/plugins/object-fit/ls.object-fit'); // eslint-disable-line global-require
}

document.addEventListener('DOMContentLoaded', () => {
  // anche se non chiami init, questo garantisce che bootstrap-italia sia incluso

  // Inizializza tutti i MediaWrapper
  document.querySelectorAll('.media-wrapper--video').forEach((el) => {
    // eslint-disable-next-line no-unused-vars
    const mediaWrapper = new MediaWrapper(el);
  });
});

// load asyncronously the SVG sprite and inject it inside the page
asyncSVG();

// initialize components
const Components = {
  header: new Header(),
  footer: new Footer(),
  pagination: new Pagination(),
  breadcrumbs: new Breadcrumbs(),
  hero: new Hero(),
  numbers: new Numbers(),
  contentWrapper: new ContentWrapper(),
  twoColumns: new TwoColumns(),
  heroCards: new HeroCards(),
  banner: new Banner(),
  faq: new Faq(),
  immobiliSlider: new ImmobiliSlider(),
  card: new Card(),
  contactModal: new ContactModal(),
  intestazione: new Intestazione(),
  portfolioImmobiliareFilterButtons: new PortfolioImmobiliareFilterButtons(),
  portfolioImmobiliareFilters: new PortfolioImmobiliareFilters(),
  portfolioImmobiliareSorter: new PortfolioImmobiliareSorter(),
  portfolioImmobiliareListing: new PortfolioImmobiliareListing(),
  shareOn: new ShareOn(),
  avvisiGara: new AvvisiGara(),
  dualColumnInfo: new DualColumnInfo(),
  documentiCorrelati: new DocumentiCorrelati(),
  galleryImmobile: new GalleryImmobile(),
  immobileTitle: new ImmobileTitle(),
  immobileContent: new ImmobileContent(),
  immobileImageComparison: new ImmobileImageComparison(),
  immobileGalleryMosaic: new ImmobileGalleryMosaic(),
  contenutoAccordion: new ContenutoAccordion(),
  privacyPolicyTable: new PrivacyPolicyTable(),
};

const PageInstance = new Page(); // must be initialized after the other components

export {
  PageInstance,
  Components,
  PageData,
  Cookies,
  Keyboard,
  Logger,
  Responsive,
  Translations,
};
